import { MoovStepPremierServiceConfigurationDTO } from "../DTO/moovStepPremierServiceConfigurationDTO";

export class MoovStepPremierServiceConfiguration{
    public id!: number;
    public moovStepConfigurationId!: number;
    public premierServiceId!: number;
    public premierServiceProductId!: number;
    public customerPremierPartnerServiceConfigurationId!: number;
    public premierPartnerId!: number;
    public premierServiceType!: string;
    public premierServiceProductType!: string;
    public status!: number; //0=Inactive, 1=Partner Inactive, 2=Active
    public parameters!: ServiceConfigurationParameter[];
    public recurrenceType!: number; //0=none, 1=every x hours, 2=every x weeks, 3=monthly on days
    public recurrenceInterval!: number; //defines the 'x' in recurrence
    public recurrenceDays!: number[]; //for weekly or monthly recurrence has comma seperated the integer representation for weekdays or days of month
    public recurrenceHour!: number; //defines the time of recurrence (hour component)
    public recurrenceMinute!: number; //defines the time of recurrence (minute component)
    public useLastDayOfMonth!: boolean; //if recurrence days contains a day some months do not have(29,30,31), then use end of month instead (true) or skip (false)
    public recurrenceStartDate!: Date; //defines on which date to start with the recurrence
    public timeZoneInfoId!: string; //timeZoneId the user selected
    public addedByUserId!: number;
    public editedByUserId!: number;
    public added!: Date;
    public edited!: Date;

    constructor(){
        this.parameters=[];
    }

    public static mapFromDTO(param:MoovStepPremierServiceConfigurationDTO):MoovStepPremierServiceConfiguration{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MoovStepPremierServiceConfiguration();
        try
        {
            obj.id = param.id;
            obj.moovStepConfigurationId = param.moovStepConfigurationId;
            obj.premierServiceId = param.premierServiceId;
            obj.premierServiceProductId = param.premierServiceProductId;
            obj.customerPremierPartnerServiceConfigurationId = param.customerPremierPartnerServiceConfigurationId;
            obj.premierPartnerId = param.premierPartnerId;
            obj.premierServiceType = param.premierServiceType;
            obj.premierServiceProductType = param.premierServiceProductType;
            obj.status=param.status;
            if(param.parameters) {
                let cpArray:any[] = JSON.parse(param.parameters);
                cpArray.forEach(cp=>{
                    let configurationParameter = new ServiceConfigurationParameter();
                    obj.parameters.push(Object.assign(configurationParameter,cp));
                });
            }
            obj.recurrenceType = param.recurrenceType;
            obj.recurrenceInterval = param.recurrenceInterval;
            if(param.recurrenceDays) obj.recurrenceDays = param.recurrenceDays.split(',').map(Number);
            obj.recurrenceHour = param.recurrenceHour;
            obj.recurrenceMinute = param.recurrenceMinute;
            obj.useLastDayOfMonth = param.useLastDayOfMonth;
            if(param.recurrenceStartDate) {               
                let date = param.recurrenceStartDate.split('T')[0].split('-'); //removes the timezone offset to show correct date in ui.  don't need to in mapToDTO as offset is handled on the server
                obj.recurrenceStartDate = new Date(Number.parseInt(date[0]),Number.parseInt(date[1])-1,Number.parseInt(date[2]),0,0,0,0);
            }
            obj.timeZoneInfoId = param.timeZoneInfoId;
            obj.addedByUserId = param.addedByUserId;
            obj.editedByUserId = param.editedByUserId;
            obj.added = new Date(param.added);
            obj.edited = new Date(param.edited);
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:MoovStepPremierServiceConfiguration):MoovStepPremierServiceConfigurationDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MoovStepPremierServiceConfigurationDTO();
        try
        {
            dto.id = param.id;
            dto.moovStepConfigurationId = param.moovStepConfigurationId;
            dto.premierServiceId = param.premierServiceId;
            dto.premierServiceProductId = param.premierServiceProductId;
            dto.customerPremierPartnerServiceConfigurationId = param.customerPremierPartnerServiceConfigurationId;
            dto.premierPartnerId = param.premierPartnerId;
            dto.premierServiceType = param.premierServiceType;
            dto.premierServiceProductType = param.premierServiceProductType;
            dto.status=param.status;
            if(param.parameters && param.parameters.length>0) dto.parameters = JSON.stringify(param.parameters);
            dto.recurrenceType = param.recurrenceType;
            dto.recurrenceInterval = param.recurrenceInterval;
            if(param.recurrenceDays) dto.recurrenceDays = param.recurrenceDays.toString();
            dto.recurrenceHour = param.recurrenceHour;
            dto.recurrenceMinute = param.recurrenceMinute;
            dto.useLastDayOfMonth = param.useLastDayOfMonth;
            if(param.recurrenceStartDate) dto.recurrenceStartDate = param.recurrenceStartDate.toISOString(); 
            dto.timeZoneInfoId = param.timeZoneInfoId;
            dto.addedByUserId = param.addedByUserId;
            dto.editedByUserId = param.editedByUserId;
            if(param.added) dto.added = param.added.toISOString();
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }

    get displayStatus(){
        switch(this.status){
            case 0:
                return "Inactive";
            case 1:
                return "Partner Inactive";
            case 2:
                return "Active";
            default:
                return "";
        }
    }
}

export class ServiceConfigurationParameter{
    public name!: string;
    public value!: string;
}